module.exports = __webpack_public_path__ + "media/asset/images/Nissay/ITRI_company_top_Nissay-86f21482e52ad3b74fa055f54c2af516.png";